import api from '~/services/api';

const getUserPlans = () =>
  api.request({
    url: '/billing/current-features/',
  });

const getPricingPlans = () =>
  api.request({
    url: '/billing/plans',
  });

const setUserPlan = (planName, isApiPlan?: boolean) => {
  // to set is_portal_user in api_apiuser table
  const devPlan = isApiPlan ? { is_portal_user: true } : {};
  return api.request({
    data: {
      plan: planName,
      ...devPlan,
    },
    method: 'POST',
    url: '/billing/plan-upgrade',
  });
};

export { getPricingPlans, getUserPlans, setUserPlan };
